export const BRAND = {
  NAME:          process.env.REACT_APP_BRAND_NAME  || 'Comment Goldmine',
  SUPPORT_EMAIL: process.env.REACT_APP_SUPPORT_EMAIL || 'support@commentgoldmine.com',
} as const;

export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_BACKEND_URL || '',
  USER_FRONTEND_URL: process.env.REACT_APP_USER_FRONTEND_URL || 'http://localhost:3000',
} as const;
